import { useMutation } from "@tanstack/react-query"
import { AddDestination, AddImage, UpdateDestination, DeleteDestination } from "../services/destinationService"

export const useUpdateImages = () => {
    const { mutate: addDestinationImage } = useMutation({
        mutationFn: ({ destinationId, image, caption, isDisplayImage }) => AddImage(destinationId, image, caption, isDisplayImage)
    })

    return addDestinationImage;
}

export const useCreateDestination = () => {
    const { mutate: createDestination } = useMutation({
        mutationFn: (destination) => AddDestination(destination)
    })

    return createDestination;
}

export const useUpdateDestination = () => {
  const { mutate: updateDestination } = useMutation({
    mutationFn: (destination) =>
      UpdateDestination(destination),
  });

  return updateDestination;
};

export const useDeleteDestination = () => {
  const { mutate: deleteDestination } = useMutation({
    mutationFn: (destination) => DeleteDestination(destination),
  });

  return deleteDestination;
};